(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    



document.addEventListener('DOMContentLoaded', function () {



  const forms = document.querySelectorAll('.cart-form');



  forms.forEach(function (form) {



    const qtyInput = form.querySelector('.quantity-input');



    if (qtyInput) {



      const qtyBtns = form.querySelectorAll('[data-qty-btn]');



      qtyBtns.forEach(function (btn) {



        btn.addEventListener('click', function (e) {



          e.preventDefault();



          let currentQty = parseInt(qtyInput.value);



          if (this.dataset.qtyBtn === 'increase') {



            qtyInput.value = currentQty + 1;



          } else if (

            this.dataset.qtyBtn === 'decrease' &&

            currentQty > 1

          ) {



            qtyInput.value = currentQty - 1;



          }



          qtyInput.dispatchEvent(

            new Event('change')

          );



        });



      });





      qtyInput.addEventListener('change', function () {



        let value = parseInt(qtyInput.value);



        if (isNaN(value) || value < 1) {



          qtyInput.value = 1;



        }



      });



    }



  });



});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle quantity buttons
  const forms = document.querySelectorAll('.cart-form');
  
  forms.forEach(form => {
    const qtyInput = form.querySelector('.quantity-input');
    const qtyBtns = form.querySelectorAll('[data-qty-btn]');
    
    qtyBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        let currentQty = parseInt(qtyInput.value);
        
        if (this.dataset.qtyBtn === 'increase') {
          qtyInput.value = currentQty + 1;
        } else if (this.dataset.qtyBtn === 'decrease' && currentQty > 1) {
          qtyInput.value = currentQty - 1;
        }
        
        // Trigger change event
        qtyInput.dispatchEvent(new Event('change'));
      });
    });
    
    // Validate quantity input
    qtyInput.addEventListener('change', function() {
      let value = parseInt(this.value);
      if (isNaN(value) || value < 1) {
        this.value = 1;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
